import m from "react";
import { getQuantTyped as i } from "../../TextArea/utils.js";
const o = _ref => {
  let {
    limitTextID: a,
    hasLimitText: l,
    value: t,
    limitTextSize: e
  } = _ref;
  return l ? m.createElement("span", {
    id: a,
    "aria-label": "".concat(i(t), " de ").concat(e, " caracteres usado"),
    className: "olx-text-input__limit-text"
  }, i(t), "/", e) : null;
};
export { o as LimitText };